import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Popup from "../../../../components/popup/Popup";
import {
  AdminPageTitle,
  AdminMainText,
  AdminSupportingText,
  AdminHeaderAction,
} from "../../../../sections/AdminDashboard/shared/adminUx";
import {
  BUSINESS_WIZARD_TITLE_CLASS,
  BUSINESS_FORM_SECTION_GAP_CLASS,
  BUSINESS_FORM_ACTION_ROW_END_CLASS,
} from "../../../../sections/BusinessDashboard/shared/businessLayoutSpec";
import { POPUP_FORM_CONTENT_CLASS } from "../../../../components/popup/popupLayoutSpec";

const Agreement = ({ clickHandler }) => {
  const [pop, setPop] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = pop ? "hidden" : "visible";
    if (!pop) document.body.style.width = "auto";
  }, [pop]);

  const popupList = [
    "You affirm that all certifications and licenses you add are current and valid.",
    "You consent to provide proof of such certifications upon a client's request.",
    "Trades Poster is not liable for any misconduct arising from uncertified services.",
    "Your agreement to these terms ensures trust and integrity in the services provided to all clients.",
  ];

  const close = () => {
    setPop(false);
    navigate(-1);
  };

  return (
    <Popup
      setTrigger={close}
      ShowCrossButton={true}
      cross={true}
      onClose={close}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={`${BUSINESS_FORM_SECTION_GAP_CLASS} w-full`}>
            <AdminPageTitle className={BUSINESS_WIZARD_TITLE_CLASS}>
              Certification consent agreement
            </AdminPageTitle>
            <AdminMainText className="text-offblack block">
              Trades Poster is currently enhancing its digital certification verification system
              to provide better service and verification for all licensed trades. During this
              period, businesses can still add certifications to their profiles manually.
            </AdminMainText>
            <AdminMainText className="text-offblack mt-3 block">
              As a business opting to manually add certifications, you agree to the following
              terms:
            </AdminMainText>
            <ul className="mt-5 space-y-2">
              {popupList.map((text, index) => (
                <li key={index} className="flex gap-3">
                  <i className="fi fi-rs-check text-sm text-primaryblue mt-0.5 flex-shrink-0" />
                  <AdminMainText className="text-offblack">{text}</AdminMainText>
                </li>
              ))}
            </ul>
            <div className={`w-full ${BUSINESS_FORM_SECTION_GAP_CLASS}`}>
              <label className="flex items-start gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  className="size-4 mt-0.5 rounded border-mediumgray text-primaryblue focus:ring-primaryblue"
                  id="agreement-terms"
                />
                <AdminSupportingText className="text-offblack block font-medium">
                  Agreement to Terms & Conditions
                </AdminSupportingText>
              </label>
              <AdminSupportingText className="pl-7 mt-2 text-mediumgray block">
                I agree to the Terms and Conditions and confirm that I am legally certified in
                the trades I am adding. I understand it is my responsibility to provide proof of
                such certifications upon request.
              </AdminSupportingText>
            </div>
            <div className={BUSINESS_FORM_ACTION_ROW_END_CLASS}>
              <AdminHeaderAction type="button" onClick={clickHandler}>
                Agree
              </AdminHeaderAction>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default Agreement;
